import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiService } from '../api.service';
import { IccMedicaidCodeImport } from '../../models/icc/icc-medicaid-code-import.model';
import { IccImportFilters } from '../../models/icc/icc-import-settings.model';
import { LimitOffsetPagingMeta } from 'app/core/models/paged-results/limit-offset-paging.model';
import { PagedResults } from 'app/core/models/paged-results/paged-results.model';

export class PagedIccMedicaidCodeImports implements PagedResults {
  medicaidCodeImports: IccMedicaidCodeImport[];
  meta: LimitOffsetPagingMeta;

  get records() {
    return this.medicaidCodeImports;
  }
}

@Injectable()
export class IccMedicaidCodeImportsService extends ApiService {
  private http = inject(HttpClient);


  get(id): Observable<IccMedicaidCodeImport> {
    return this.http.get<IccMedicaidCodeImport>(`${environment.captureApi.url}/icc/medicaid_code_imports/${id}`);
  }

  getList(
    paging: { page: number; pageSize: number } = null,
    filters: IccImportFilters = null
  ): Observable<PagedIccMedicaidCodeImports> {
    const params = new URLSearchParams();

    if (filters && filters.selectedClientIds) {
      filters.selectedClientIds.forEach(clientId => params.append('client_ids[]', clientId));
    }

    if (paging) {
      params.append('page', paging.page.toString());
      params.append('per_page', paging.pageSize.toString());
    }

    return this.http.get<PagedIccMedicaidCodeImports>(
      `${environment.captureApi.url}/icc/medicaid_code_imports?${params.toString()}`
    );
  }

  create(clientId: number, name: string, signedId: string): Observable<IccMedicaidCodeImport> {
    return this.http.post<IccMedicaidCodeImport>(`${environment.captureApi.url}/icc/medicaid_code_imports`, {
      medicaidCodeImport: { clientId, name, signedId },
    });
  }

  update(id, name): Observable<IccMedicaidCodeImport> {
    return this.http.put<IccMedicaidCodeImport>(`${environment.captureApi.url}/icc/medicaid_code_imports/${id}`, {
      medicaidCodeImport: { name },
    });
  }

  cancel(id): Observable<IccMedicaidCodeImport> {
    return this.http.patch<IccMedicaidCodeImport>(
      `${environment.captureApi.url}/icc/medicaid_code_imports/${id}/cancel`,
      {}
    );
  }
}
